<p-tabView>

    <p-tabPanel header="Datos">
      <div class="p-grid">
        <div class="p-col-3 p-field">
          <label for="name">Nombre</label>
          <input name="name" type="text" pInputText [(ngModel)]="entity.name" required />
        </div>
        <div class="p-col-4 p-field">
          <label for="name_plural">Nombre plural</label>
          <input name="name_plural" type="text" pInputText [(ngModel)]="entity.name_plural" required />
        </div>
        <div class="p-col-3 p-field">
          <label for="shortname">Nombre corto</label>
          <input name="shortname" type="text" pInputText [(ngModel)]="entity.shortname" />
        </div>
        <div class="p-col-2 p-field">
          <p-button label="Guardar" icon="pi pi-check" styleClass="p-mt-3" (click)="save()"></p-button>
        </div>
      </div>
      <p-card styleClass="p-card-content-fit">      

        <ng-template pTemplate="header">
          <div class="p-card-title">
            Campos adicionales
            <div class="p-card-title-actions" *ngIf="create_fields && entity.allow_metadata">
              <a (click)="edit(null)">
                <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>Nuevo campo
              </a>
            </div>
          </div>
        </ng-template>
        <p-table #grid [value]="entitiesFields" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
                 [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                 currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                 [rowsPerPageOptions]="[25,50, 100]" [reorderableColumns]="true" (onRowReorder)="onRowReorder($event)">
          <ng-template pTemplate="header">
            <tr>
              <th width="35"></th>
              <th width="50" pSortableColumn="position">Orden</th>
              <th pSortableColumn="name" width="150">Nombre</th>
              <th pSortableColumn="description">Descripción</th>
              <th width="100"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entityField let-index="rowIndex">
            <tr (dblclick)="edit(entityField)" [pReorderableRow]="index">
              <td width="35">
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td width="50">{{entityField.position}}</td>
              <td>{{entityField.name}}</td>
              <td>{{entityField.description}}</td>
              <td class="grid-actions">
                <a (click)="edit(entityField)">
                  <fa-icon [icon]="['far', 'edit']"></fa-icon>
                </a>
                <a (click)="delete(entityField)" *ngIf="!entityField.is_base_field" class="color-danger">
                  <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                </a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </p-tabPanel>
    <p-tabPanel header="Configuración" >
        <form #formDetails="ngForm">
            <p-card header="Detalles">
                <div class="p-grid">
                    <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="modelMonaco"
                        [ngModelOptions]="{standalone: true}" (init)="editorInit($event)"
                        (ngModelChange)="onMonacoChange($event)" style="height: 500px; width: 100%;">
                    </ngx-monaco-editor>
                </div>
                <ng-template pTemplate="footer">
                    <div class="p-d-flex">
                        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text"
                            (click)="cancel()"></p-button>
                        <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
                    </div>
                </ng-template>
            </p-card>

        </form>

    </p-tabPanel>
    <p-tabPanel header="Duplicidad de datos">
        <div class="p-grid">
            <div *ngFor="let entityField of entitiesFieldsForDuplicities" class="p-col-3">
                <p-checkbox name="duplicities" value="{{entityField.id}}" label="{{entityField.description}}"
                    [(ngModel)]="selectedEntities"></p-checkbox>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="p-d-flex" style="text-align:right;">
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()">
                </p-button>
                <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
            </div>
        </ng-template>
    </p-tabPanel>
</p-tabView>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="header">
        <h3>Confirmación de borrado</h3>
    </ng-template>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Sí" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
